import React from "react";
import PropTypes from "prop-types";
import { Box, Divider } from "@mui/material";

import Card from "../Card";
import GoogleMaps from "../GoogleMaps";
import messages from "../../assets/locale/messages";
import { useSelector } from "react-redux";
import "../Events/Event/_EventDetailFields.scss";

import "./EventLocation.scss";
const DEFAULT_COORDS = { coords: { lat: 24.7136, lng: 46.6753 } };

const EventLocation = ({ lat, lng, address, radius, city }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events.viewEvents;

  const hasCoords = Boolean(lat && lng);
  const mapCoords = hasCoords
    ? { coords: { lat: Number(lat), lng: Number(lng) } }
    : DEFAULT_COORDS;

  return (
    <Card
      title={t.location}
      classNames={{
        body: "p-0",
      }}
    >
      <GoogleMaps
        viewOnly={true}
        isMarker={hasCoords}
        showCircle={hasCoords && Boolean(radius)}
        circleRadius={Number(radius) || 0}
        savedCoords={mapCoords}
        updatedPosition={mapCoords}
        wrapperClasses="event-location__map-wrapper"
        getCoords={() => {}}
        markerMoved={() => {}}
        className="event-location__map"
      />

      <Box
        sx={{ px: 2, pb: 2, display: "flex", flexDirection: "column", gap: 2 }}
      >
        <div className="event-detail-field">
          <span className="event-detail-label">{t.city}</span>
          <span className="event-detail-value">{city?.name || "—"}</span>
        </div>
        <div className="event-detail-field">
          <span className="event-detail-label">{t.eventLocation}</span>
          <span className="event-detail-value">
            {address || t.noLocation}
          </span>
        </div>
        <Divider />
        {hasCoords && (
          <Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
            <span className="event-detail-label">{t.diameter}</span>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
              }}
            >
              <span className="event-location__radius-value">
                {radius ? `${radius} ${t.meters}` : "—"}
              </span>
              <span className="event-location__radius-hint">
                {t.radiusFromCenter}
              </span>
            </Box>
          </Box>
        )}
      </Box>
    </Card>
  );
};

EventLocation.propTypes = {
  lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  address: PropTypes.string,
  radius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  city: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
};

EventLocation.defaultProps = {
  lat: null,
  lng: null,
  address: "",
  radius: null,
  city: null,
};

export default EventLocation;
